﻿import {IDomainEvent} from './DomainEvent';

export class DomainEventBus {
    static raise(args: IDomainEvent) {
        let customEvent: CustomEvent = new CustomEvent(args.name, {detail: args});
        document.dispatchEvent(customEvent);
    }
}